import { castArray } from '../views/utils'

/* eslint-disable no-unused-expressions, no-use-before-define, no-shadow */
// const one = arr => isArray(arr) ? arr[0] : arr

const appendAuth = ({ auth }) => (child) => {
  if (!auth) return child

  return Object.assign({},
    child,
    {
      auth: castArray(child.auth ? child.auth : auth),
    },
  )
}

const flatten = children =>
  children.reduce((arr, route) => {
    arr.push(route.auth ? Object.assign(route, { auth: castArray(route.auth) }) : route)
    if (route.children) {
      arr.push(...flatten(route.children.map(appendAuth(route))))
    }
    return arr
  }, [])

export default (router, routes) => {
  const checkRoute = (to, from) =>
    doChecks(to, from).catch((err) => {
      router.replace({ name: (err && err.code) ? `Err${err.code}` : 'Login' })
    })

  // router.beforeEach((to, from, next) =>
  //   checkRoute(to, from)
  //     .then(() => next()))

  let getters
  const doChecks = (to, from) => {
    const auth = routesAuth[to.name]
    if (!auth) return Promise.resolve()

    getters = router.app.$store.getters

    return getters.whenAuth.then(() => doAllAuth(auth, to))
  }

  const routesAuth = flatten(routes)
    .filter(route => route.name)
    .reduce((acc, { name, auth }) => {
      acc[name] = auth || null
      return acc
    }, {})

  // const passAuth = to => ({ memberRole, role, userIdIn }) => {
  const passAuth = to => (authorizationChecks) => {
    const { permissions } = authorizationChecks
    // const { _user: user, hasRoles, hasGroupRoles } = getters
    const { hasPermissions } = getters
    const validations = []

    // if (role) validations.push(hasRoles(role))

    // if (memberRole) validations.push(hasGroupRoles(memberRole))

    // if (author) {
    //   validations.push(queryContext(to).then(context =>
    //     Promise.resolve(context && context.author_id === user.id)))
    // }

    // if (userIdIn) {
    //   validations.push(queryContext(to).then(context =>
    //     Promise.resolve(context && context.admins.includes(user.id))))
    // }

    if (permissions) {
      validations.push(hasPermissions(...permissions))
    }

    return Promise.all(validations)
      .then(res =>
        Promise.resolve(res.every(re => re)))
  }

  /* eslint-disable prefer-promise-reject-errors */
  function doAllAuth(auth, to) {
    if (!getters.isAuth) return Promise.reject()

    // return undefined
    return Promise
      .all(auth.map(passAuth(to)))
      .then(res => res.some(re => re) ? Promise.resolve() : Promise.reject({ code: 401 }))
  }
  /* eslint-enable prefer-promise-reject-errors */

  // function queryContext(to) {
  //   // auto identify context
  //   const contextGuess = to.path.split('/')[1]
  //   const getterKey = Object
  //     .keys(getters)
  //     .find(key => key
  //       .toLowerCase()
  //       .includes(`query${contextGuess}`))

  //   if (!getterKey) return {}

  //   const res = getters[getterKey](Object.assign({}, to.params, { $limit: 1 }))
  //   if (typeof res === 'undefined') {
  //     return router.app.$store.dispatch(`FETCH_${contextGuess.toUpperCase()}S`, to.params).then(response =>
  //       Promise.resolve(one(response)))
  //   }

  //   return Promise.resolve(res)
  // }

  return { checkRoute, doChecks }
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/router/beforeEach.js